<div class="flex flex-col w-full h-full">
    <!-- Header -->
    <div mat-dialog-title class="flex flex-0 items-center justify-between h-12">
        <div class="text-lg font-medium">Quote <b>{{view.itin?.content?.itinerary?.reference}}</b></div>
        <button mat-icon-button (click)="close()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>

    <mat-dialog-content class="p-2" style="max-height: 100%;">
        <p *ngIf="view.itin?.content?.itinerary && view.itin.content.itinerary.pax > 0 && (view.itin.content.itinerary.balance != null || view.itin.content.itinerary.balanceCurrent != null)" class="text-sm text-gray-600 mb-2">
            Total ZAR: {{ (view.itin.content.itinerary.balanceCurrent ?? view.itin.content.itinerary.balance) | currency:'ZAR':'symbol-narrow' }}
        </p>
        <iframe [src]="view.quoteViewUrl" width="100%" height="100%" frameBorder="0"></iframe>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Close</button>
        <button mat-flat-button [disabled]="true">
            <span class="inline-flex items-center"><mat-icon class="mr-1.5 icon-size-5" [svgIcon]="'mat_outline:share'"></mat-icon> Share</span>
        </button>
        <a mat-flat-button cdkFocusInitial [href]="view.quoteDownloadUrl" target="_blank">
            <span class="inline-flex items-center"><mat-icon class="mr-1.5 icon-size-5" [svgIcon]="'mat_outline:file_download'"></mat-icon> Download</span>
        </a>
    </mat-dialog-actions>
</div>